import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'

import {LoaderLineComponent} from './loader-line.component'

@NgModule({
  imports: [CommonModule],
  declarations: [LoaderLineComponent],
  exports: [LoaderLineComponent],
})
export class LoaderLineModule {}
